export default __webpack_public_path__ + "static/media/1_5_logo.cde028a4.png";